<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="maCS" nzRequired>Mã</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="qualificationCode" name="maCS" type="text" placeholder="Nhập mã" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="tenCS" nzRequired>Trình độ chuyên môn</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="qualificationName" name="tenCs" type="text" placeholder="Nhập trình độ chuyên môn">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired #label nzFor="gender">Loại ngành:</nz-form-label>
          <nz-form-control nzSpan="24">
            <nz-radio-group  formControlName="qualifications">
              <label nz-radio [nzValue]="1">Ngành sư phạm</label>
              <label nz-radio [nzValue]="2">Ngành khác</label> 
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu & Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <button nz-button (click)="close()" [disabled] = "isDisabled">Đóng</button>&nbsp;
        <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>